import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'priceFormat',
	standalone: true,
})
export class PriceFormatPipe implements PipeTransform {
	private readonly locale = inject(LOCALE_ID);

	transform(priceInPennies: number | null | undefined): string {
		if (priceInPennies === null || priceInPennies === undefined) return '';
		return new Intl.NumberFormat(this.locale, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		}).format(priceInPennies / 100);
	}
}
